import styled from '@emotion/styled';
import type { FC } from 'react';
import { Outlet } from 'react-router';
import { upTo } from 'src/lib/customHooks/useBreakpoint';

export const MessageTemplatesView: FC = () => {
  return (
    <Container>
      <Outlet />
    </Container>
  );
};

const Container = styled.div`
  position: absolute;
  padding: 10px;
  top: 50px;
  bottom: 0;
  left: 0;
  right: 0;

  @media ${upTo('tablet')} {
    padding: 0px;
  }
`;
